import { put, call } from 'redux-saga/effects';
import {aflt_stcbonusList, aflt_stcbonusAdd, aflt_stcbonusUpdate, aflt_stcbonusDelete } from '../../../services/settings/affiliates/aflt_stcbonusService';

import * as types from '../../../actions';

export function* aflt_stcbonusListSaga(payload) { 
    try {
      const response = yield call(aflt_stcbonusList, payload);
      yield put({ type: types.STCBONUS_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.STCBONUS_LIST_AFFILIATE_ERROR, error });
    }
} 

export function* aflt_stcbonusAddSaga(payload) { 
    try {
      const response = yield call(aflt_stcbonusAdd, payload);
      yield put({ type: types.STCBONUS_ADD_AFFILIATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.STCBONUS_ADD_AFFILIATE_ERROR, error });
    }
}

export function* aflt_stcbonusUpdateSaga(payload) {
  try {
    const response = yield call(aflt_stcbonusUpdate, payload);
    yield put({ type: types.STCBONUS_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.STCBONUS_UPDATE_AFFILIATE_ERROR, error });
  }
}

export function* aflt_stcbonusDeleteSaga(payload) {
  try {
    const response = yield call(aflt_stcbonusDelete, payload);
    yield put({ type: types.STCBONUS_DELETE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.STCBONUS_DELETE_AFFILIATE_ERROR, error });
  }
}


